import {h} from '@stencil/core';
import type {GuidedV2Emitters} from '../../models/eventNames';
import {MegaBanner} from '../../../design-system/mega-banner/mega-banner';

export interface GuidedFooterBannerProps {
    /**
   * Text to show in the banner, the bolded line
   * @type {string}
   */
  text: string;
    /**
   * @typedef {string} description
   * @description A descriptive text that provides more detailed information about an item or entity. The not bolded line.
   */
  description: string;
    /**
   * Represents the text label displayed on a button.
   * This string is typically used to inform the user of the button's action.
   */
  buttonText: string;
    /**
   * The URL hyperlink reference.
   *
   * Represents a reference to a web resource, typically a URL.
   * Used to specify the target location for hyperlinks.
   *
   * @type {string}
   */
  href: string;
    /**
   * Specifies where to open the linked document.
   * Common values:
   * - `_self`: Opens in the same frame.
   * - `_blank`: Opens in a new tab or window.
   * - `_parent`: Opens in the parent frame.
   * - `_top`: Opens in the full body of the window.
   */
  target?: string;
    /**
   * Represents the source path or URL of an image.
   *
   * Type: string
   */
  src?: string;
  eventEmitters: GuidedV2Emitters;
}

//Must be demoed in: `<main class="qds-platform-desktop">`

export const GuidedFooterBanner = (props: GuidedFooterBannerProps) => {

    const {text, description, buttonText, href, target, src, eventEmitters} = props;

    return <div class="guided-v2-section__footer">
      <MegaBanner
        text={text}
        description={description}
        buttonText={buttonText}
        href={href}
        src={src}
        target={target}
        eventEmitters={eventEmitters}
      />
    </div>;
};
